import { render, staticRenderFns } from "./EditIngredient.vue?vue&type=template&id=3c9d8bba"
import script from "./EditIngredient.vue?vue&type=script&lang=js"
export * from "./EditIngredient.vue?vue&type=script&lang=js"
import style0 from "./EditIngredient.vue?vue&type=style&index=0&id=3c9d8bba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports